export default __webpack_public_path__ + "static/media/tree_View.d78efdff.svg";